import React, { useEffect, useState, useRef } from 'react'
import styled from '@emotion/styled'
import Spinner from './spinner.js'
import { BrowserUtils } from '../../utils/siteUtils'
import { getTheme } from '../../constants/themes.js'

const Container = styled('div')`
  width: 100%;
  position: relative;
  ${p => (p.backgroundColor ? `background-color: ${p.backgroundColor};` : '')}
`

const LoadingWrapper = styled('div')`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 50px;
  width: 100%;
  z-index: 0;
`

const ComponentContainer = styled('div')`
  background-color: ${p => p.backgroundColor || 'white'};
  position: relative;
  z-index: 3;
  width: 100%;
  max-width: ${props => props.maxWidth};
  margin: auto;
`

const implementedComponents = ['condition', 'imagecapture', 'breadcrumb', 'vehicleDetails', 'vehicleDetailsKeysMods', 'landing', 'offer-request']

const WebComponentContainer = ({ children, pageLoadingComplete, withLoader, location, maxWidth = '95%', theme }) => {
  const componentWrapperReference = useRef(null)
  const [height, setHeight] = useState(0)
  const { backgroundColor } = getTheme(theme) || {}

  const onLoad = () => {
    setHeight(componentWrapperReference?.current?.scrollHeight)
  }
  useEffect(() => {
    onLoad()
  })

  useEffect(() => {
    if (BrowserUtils.isIframe()) {
      if (location !== 'breadcrumb') {
        let adjustedHeight = 0
        if (location === 'landing') {
          adjustedHeight = height
        } else {
          adjustedHeight = height !== 0 ? height + 300 : height // adjusted for breadcrumb
        }
        setTimeout(function () {
          BrowserUtils.emitComponentSize(adjustedHeight, location)
        }, 500)
      }
    }
  }, [height, location])

  return (
    <Container ref={componentWrapperReference} id={'BodyDivFlex'} maxWidth={maxWidth} backgroundColor={backgroundColor}>
      {/* 
      // Because eventing is inconsistent with the UI, 
      // this Loader is meant to be always on. 
      // The web component will render on top of it when it is ready. 
      */}
      {withLoader && <LoadingWrapper>{location === 'landing' ? <Spinner size="30px"></Spinner> : <ico-loading-spinner class={theme ? `${theme}-theme` : ''} />}</LoadingWrapper>}
      <ComponentContainer maxWidth={maxWidth} id={'WebComponentContainer-' + location} backgroundColor={backgroundColor}>
        <style>{`:root{font-size:16px;}`}</style>
        {
          // ICO Web compnents need to be rendered on the 2nd render cycle to resolve
          // any event timing issues on first load.
          !pageLoadingComplete ? <></> : children
        }
      </ComponentContainer>
    </Container>
  )
}

WebComponentContainer.displayName = 'WebComponentContainer'

export default WebComponentContainer
